import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatUnlinkedPayload = z.object({
    loanRequestId: schemaId,
});

export type Schema_ChatUnlinkedPayload = z.infer<typeof schemaChatUnlinkedPayload>;
